import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./Reveal";

export const FAQS = [
  {
    q: "What is included in a Dune Villas stay?",
    a: "Every Dune Villa stay includes six bedrooms, access to the swimming pool, and complimentary breakfast and dinner for your group. Lunch (₹900 per person) and a safari experience (₹2,000 per person) can be added on.",
  },
  {
    q: "What are the check-in and check-out times?",
    a: "Check-in is at 3 PM and check-out is at 11 AM.",
  },
  {
    q: "Can I make a reservation for a specific room at Area 83?",
    a: "Yes, you can make a reservation for a specific room at Area 83, subject to availability. Be sure to mention your preferences when making your reservation.",
  },
  {
    q: "What amenities are included in the rooms at Area 83?",
    a: "All rooms at Area 83 come with a private bathroom, air conditioning, flat-screen TV, and comfortable bedding. Some rooms may also include additional amenities such as an electrical kettle, room service in suite, iron box with iron stand, and in-room safe.",
  },
  {
    q: "Is room service available for rooms at Area 83?",
    a: "Yes, room service is available for rooms at Area 83. Guests can enjoy a variety of delicious meals and snacks from the comfort of their own room.",
  },
  {
    q: "Is there a minimum stay requirement for rooms at Area 83?",
    a: "Yes, there is a minimum stay requirement for rooms at Area 83. The minimum stay varies depending on the season and the type of room booked, so be sure to check with the resort when making your reservation.",
  },
  {
    q: "Are there any age restrictions for guests staying at Area 83?",
    a: "There are no specific age restrictions for guests staying in rooms at Area 83. However, children under the age of 18 must be accompanied by an adult.",
  },
  {
    q: "Is parking available for guests at Area 83?",
    a: "Yes, there is ample parking available for guests staying in rooms at Area 83. The resort offers free on-site parking for all guests.",
  },
];

export const Faqs = () => (
  <section id="faqs" data-testid="faqs-section" className="bg-brand-ivory py-20 lg:py-36">
    <div className="mx-auto grid max-w-7xl gap-10 px-6 sm:px-8 lg:grid-cols-12 lg:gap-20">
      <Reveal className="lg:col-span-5">
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand-moss">FAQs</p>
        <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-brand-licorice sm:text-5xl">
          Frequently Asked Questions
        </h2>
        <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-brand-licorice/70 sm:text-base">
          For any further queries, call us on{" "}
          <a href="tel:+918046396067" data-testid="faqs-call-link" className="text-brand-brunswick underline underline-offset-4 hover:opacity-70">
            +91 80463 96067
          </a>{" "}
          and we&rsquo;ll help you plan your stay.
        </p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible data-testid="faqs-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-brand-licorice/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left font-serif text-xl font-normal text-brand-licorice hover:text-brand-brunswick hover:no-underline sm:text-2xl"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-base leading-relaxed text-brand-licorice/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
